var lib_core = require("lib-core");
var editor_2d = require("editor-2d");

var SymbolTerminalToolStateMachine = require("./symbolTerminalToolStateMachine.js");

var SymbolTerminalToolController = function(archLayers, dependencies, configuration) {
    this.setDefaultConfiguration({
            multiplePlacing: true
        });

    editor_2d.AbstractToolController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(SymbolTerminalToolController, editor_2d.AbstractToolController);
SymbolTerminalToolController.inject = lib_core.clone(editor_2d.AbstractToolController.inject);
SymbolTerminalToolController.StateMachineClass = SymbolTerminalToolStateMachine;

module.exports = SymbolTerminalToolController;

SymbolTerminalToolController.prototype.getButtonElements = function () {
    var buttonElements = {
        name: 'Terminal',
        title: 'Terminal',
        style: {
            icon: 'icon-terminal.svg'
        },
        eventData: {
            "tool": this.name()
        }
    };

    return buttonElements;
};
